/**
 * DSN проектов GlitchTip (sentry.teamplay.gg, org "teamplay") по платформе и окружению.
 *
 * Отдельный модуль без импортов: таблицу читает и приложение (`dsn.ts`), и сборка
 * (`vite.config.ts` подставляет DSN в страницу "Обновите WebView", где бандла нет). Конфиг
 * сборки не знает `import.meta.env` и алиасов проекта, поэтому здесь только константы.
 *
 * DSN - публичные ключи приёма, они и так уходят в клиентский бандл, поэтому живут в коде:
 * так маршрутизация работает на любом пути сборки без шести переменных в CI.
 */
export const SENTRY_DSN = {
  webDev: 'https://60611801f3f94f66bc5f0c7312886db1@sentry.teamplay.gg/2',
  webProd: 'https://39097be5eb27469a90fa8c951941bb22@sentry.teamplay.gg/3',
  androidDev: 'https://7d0189e0827c4f6bbe2bc539d3324f89@sentry.teamplay.gg/4',
  androidProd: 'https://038f83fcc9644ea182a894c111dc8dab@sentry.teamplay.gg/5',
  iosDev: 'https://20931329f66f41fd8fca6431ec1308f7@sentry.teamplay.gg/6',
  iosProd: 'https://47f54c85d4054dcdbbb53c3a75919d8b@sentry.teamplay.gg/7',
} as const;
